import React from 'react';
import { useDispatch } from 'react-redux';
import { setGetMailingStatisticsScrollerUsersDeposits } from '../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerUsersDeposits';
import Users from './components/users';

const CountUsersDeposits = ({
    id
}) => {

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetMailingStatisticsScrollerUsersDeposits({
            mailing_id: id,
            page: 1,
            pageSize: 25
        }))
    }, [])

    return (
        <div>
            <div>
                <h3 style={{
                    color: "#FFFFFF",
                    fontWeight: 700,
                }}>Пользователи с депозитами</h3>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Users mailing_id={id} />
            </div>
        </div >
    )
}

export default CountUsersDeposits;